// We serve active from different domains depending
// on the environment. We need to know which URL
// to use for a given environment (development, staging, prod).
// https://www.strava.com
// https://www.staging.strava.com
// http://localhost + port
// http://127.0.0.1 + port

// Note: When developing locally, we will serve this web app
// on a different port than active
const LOCALHOST_ACTIVE_PORT = 3000;

export function extractUrlFromReq(req) {
  let fullHost = req.headers['x-forwarded-host'] || req.headers.host;
  let protocol = 'https';

  // If we are developing locally, we will be running
  // active on some other port, so we set it here:.
  if (fullHost.includes('localhost')) {
    fullHost = `localhost:${LOCALHOST_ACTIVE_PORT}`;
    protocol = 'http';
  }

  return `${protocol}://${fullHost}`;
}

export function baseUrlFromWindow() {
  const { location } = window;

  // If we are on the browser, and have included a port in the location URL, then
  // we are running locally, and the api client should use active's port.
  const port = location.port === '' ? '' : `:${LOCALHOST_ACTIVE_PORT}`;

  return `${location.protocol}//${location.hostname}${port}`;
}
